import React, { useState, useRef, } from 'react';

import Loader from 'react-loader-spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';

const PremiumUserForm = (props) => {


    const [saving, setSaving] = useState(false)
    const [isFormShow, setIsFormShow] = useState(false);
    const [email, setEmail] = useState('');
    const [tournaments, setTournaments] = useState(3);

    const accordionBtn = useRef();

    const handleShowForm = () => {
        setIsFormShow(!isFormShow);
        setEmail('');
        setTournaments(3);
    }

    const hideForm = () => {
        if (isFormShow) accordionBtn.current.click();
    }

    const invalid = email === '' || tournaments === '';

    const onSubmit = (e) => {
        e.preventDefault();
        if (!invalid && !saving) {
            setSaving(true);
            const createUserPremium = props.firebase.createUserPremium();
            createUserPremium({ email: email, tournaments: tournaments })
                .then((result) => {
                    setSaving(false);
                    if (result.data && result.data.code && result.data.code === 200) {
                        hideForm();
                        props.showModal("Info", "El usuario se creó con éxito");
                    } else {
                        props.showModal("Error", "No se pudo crear el usuario");
                    }
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    setSaving(false);
                    props.showModal("Error", "No se pudo crear el usuario");
                });
        }
    }

    const textButtom = isFormShow ? 'Ocultar' : 'Añadir Usuario';
    const iconButton = isFormShow ? faAngleUp : faAngleDown;

    return (
        <div className="bg-white border rounded-lg accordion p-2" id="accordionOfferForm">
            <div className="nav justify-content-between align-items-center">
                <h6 className="font-weight-bolder m-0">Listado de usuarios</h6>

                <button ref={accordionBtn} onClick={handleShowForm} className="btn btn-second btn-sm" type="button" data-toggle="collapse" data-target="#offerFormCollapse" aria-expanded="true" aria-controls="offerFormCollapse">
                    <span className="mr-2 d-none d-md-inline">{textButtom}</span>
                    <FontAwesomeIcon className="" icon={iconButton} />
                </button>
            </div>
            <div id="offerFormCollapse" className="collapse hide" data-parent="#accordionOfferForm">
                <div className=" pl-2 pr-2">
                    {/* <span className="font-weight-bolder ml-2">Añadir Usuario</span> */}

                    <form onSubmit={onSubmit}>
                        <div className="row m-0">
                            <div className="col row pl-0 pr-0 m-0">
                                <div className="col col-12 col-sm-9 p-2">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="email">Correo electrónico:</label>
                                    <input className="form-control form-control-sm" value={email} type="email" onChange={(e) => setEmail(e.target.value)} id="email" name="email" placeholder="exemplo@mail.com" />
                                </div>
                                <div className="col col-12 col-sm-3 p-2">
                                    <label className="small text-secondary mb-0 ml-1" htmlFor="tournaments">Torneos:</label>
                                    <input className="form-control form-control-sm" value={tournaments} type="number" onChange={(e) => setTournaments(e.target.value)} id="tournaments" name="tournaments" placeholder="#" min="0" max="999999" />
                                </div>
                            </div>

                            {(!saving) ?
                                <div className="col-12 row pl-0 pr-0 m-0 justify-content-end">
                                    <button disabled={invalid} type="submit" className="btn btn-sm btn-success m-2">Guardar</button>
                                </div>
                                :
                                <div className="col-12 row nav justify-content-center">
                                    <Loader className="m-2"
                                        type="ThreeDots"
                                        color="#263238"
                                        height={30}
                                        width={60}
                                        timeout={0} />
                                </div>
                            }
                        </div>

                    </form>
                </div>
            </div>
        </div >
    )

}

export default withFirebase(PremiumUserForm);
